import { fetcher } from '@commenda/utils';

export const runBillingUsageTest = (
  quoteId: string,
  params: { optionId: string; quantity: number; batchId?: string }
) =>
  fetcher(`commenda-billing/quotes/${quoteId}/usage-test-runs`, {
    method: 'POST',
    body: params,
  });
